import { render, staticRenderFns } from "./distribution-ratio.vue?vue&type=template&id=0380d931&scoped=true"
import script from "./distribution-ratio.vue?vue&type=script&lang=js"
export * from "./distribution-ratio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0380d931",
  null
  
)

export default component.exports